import React from "react";
import Button from "../../../component-lib/Molecules/button/Button";

type ClearFiltersButtonProps = {
  onClear: () => void;
  disabled?: boolean;
};

const ClearFiltersButton = ({
  onClear,
  disabled = false,
}: ClearFiltersButtonProps) => {
  return (
    <Button
      label="Clear Filters"
      variant="outlined"
      onClickCb={onClear}
      disabled={disabled}
      style={{
        paddingTop: "6px",
        paddingBottom: "6px",
        minWidth: "140px",
        backgroundColor: "white",
        border: "1px solid #D2D2D2",
        color: "#005596",
      }}
    />
  );
};

export default ClearFiltersButton;
